import { Edit } from '@mui/icons-material';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import { FC, useCallback } from 'react';
import {
  Datagrid,
  FieldProps,
  List,
  Link,
  Loading,
  TextField,
  useShowController,
  useRecordContext,
  BooleanField,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

export const ExtensionField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { extension } = value;
  if (String(extension) === 'pdf') {
    return <span>Инструкция</span>;
  }
  return <span>Характеристики</span>;
};

export const LinkFileEditField = (props: FieldProps) => {
  const value = useRecordContext(props);
  const { id } = value;
  console.log(id);
  let link = '/files/' + String(id);
  return <Link to={link}>Редактировать</Link>;
};

export const ProductShow: FC = () => {
  const data = useShowController();
  const navigate = useNavigate();
  const { record: { id } = {}, isLoading, isFetching } = data;

  const handleClickEdit = useCallback(() => {
    navigate(`/products/${id}`);
  }, [id, navigate]);

  if (isLoading || isFetching) {
    return <Loading />;
  }
  const list: any[] = [];
  if (data.record.files) {
    data.record.files.forEach((file: any) => {
      list.push(<li>{file.original_name}</li>);
    });
  }
  let filter = {
    files: data.record.files,
  };
  let is_active_text: string = 'Не активно';
  if (data.record.is_active) {
    is_active_text = 'Активно';
  }
  return (
    <Card>
      <CardHeader
        title={`${data.record.name}`}
        subheader={data.record.article}
        action={
          <IconButton aria-label="Edit" onClick={handleClickEdit}>
            <Edit />
          </IconButton>
        }
      />
      <CardContent>
        <b>Артикуль: </b>
        {data.record.article}
        <br />
        <b>Имя: </b>
        {data.record.name}
        <br />
        <b>Описание: </b>
        {data.record.description}
        <br />
        <b>Цена: </b>
        {data.record.price}
        <br />
        <b>Количество: </b>
        {data.record.count}
        <br />
        <b>Статус: </b>
        {is_active_text}
        <br />
        <br />
        <span>Список файлов:</span>
        <List
          emptyWhileLoading
          resource="files_product"
          filter={filter}
          exporter={false}
        >
          <Datagrid>
            <TextField source="id" />
            <ExtensionField source="extension" label="Тип файла" />
            <TextField source="description" label="Полное имя файла" />
            <BooleanField source="is_active" label="Активен" />
            <LinkFileEditField source="id" label="Редактировать" />
          </Datagrid>
        </List>
      </CardContent>
    </Card>
  );
};
